module.exports = __webpack_public_path__ + "img/hero.29d7b1ef.jpg";